import React from "react";
import {
  f7,
  App,
  Panel,
  Views,
  View,
  Popup,
  Page,
  Navbar,
  NavRight,
  Link,
  Block,
  BlockTitle,
  Icon,
  List,
  ListItem,
  ListItemCell,
  Row,
  Col,
  Range,
  Toggle,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
} from "framework7-react";

import Fmb from "./crumbs";

import cordovaApp from "../js/cordova-app";
import routes from "../js/routes";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import {
  withFirebase,
  withFirestore,
  firebaseConnect,
  firestoreConnect,
} from "../HOCs";
import { Collections, DocArray, Doc } from "../utils/_classes";
import { CART } from "../store/actions/cart";
import {
  CHANGE_RANGE,
  CHANGE_MENU_ADD,
  CHANGE_MENU_REMOVE,
} from "../store/actions/menu";
import { initAuth } from "../store/actions/firebase";
import {
  urlBase64ToUint8Array,
  toast,
  handleErrors,
  notifyUser,
} from "../utils/_helpers.js";
import runtime from "serviceworker-webpack-plugin/lib/runtime";
import { functions } from "firebase";
import moment from "moment";

class MainApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Menu
      menu: [],
      searchRadius: 50,
      // For initial auth load
      // count: 0,
      // Framework7 Parameters
      f7params: {
        id: "com.easychaw.webapp", // App bundle ID
        name: "Easychaw", // App name
        theme: "aurora", // Automatic theme detection
        version: "3.2.2", //App version
        cache: false,
        // App root data
        data: function () {
          return {
            user: {
              firstName: "John",
              lastName: "Doe",
              readme:
                "to use this data in any page use eg: this.$f7.data.user.firstname",
            },
          };
        },

        // App root methods
        methods: {
          intents: {
            openMap: function (geolocation) {
              try {
                cordova.InAppBrowser.open(
                  encodeURI(
                    "http://maps.apple.com/?ll=" +
                      geolocation.lat +
                      "," +
                      geolocation.lng +
                      "&z=10&t=s",
                  ),
                  "_system",
                  "location=no,usewkwebview=yes",
                );
              } catch (error) {}
            },
            openStore: function (link) {
              try {
                cordova.InAppBrowser.open(
                  encodeURI(link),
                  "_system",
                  "location=no,usewkwebview=yes",
                );
              } catch (error) {}
            },
          },
          phoneCall: (contact) => {
            if (!this.$device.cordova)
              cordova.InAppBrowser.open(
                encodeURI("tel://" + contact),
                "_system",
                "location=no,usewkwebview=yes",
              );
          },
          sendEmail: function (to) {
            if (!this.$device.cordova)
              cordova.InAppBrowser.open(
                encodeURI("mailto:" + to),
                "_system",
                "location=no,usewkwebview=yes",
              );
          },
          showFullText: function () {
            const self = this;
            self.$(".show-text").click(function () {
              self.dialog.alert(self.$(this).find(".item-title").text());
            });
          },
          navAccount: function (which, ...args) {
            this.views.account.router.navigate(`/account/${which}/`, {
              reloadAll: true,
            });
            this.tab.show(`#tab-${which}`, false);
            switch (args[0]) {
              case "purchase history":
                this.views.account.router.navigate("/profile/1/", {
                  //reloadAll: true,
                });
                break;
              case "wallet":
                this.views.account.router.navigate("/profile/2/", {
                  //reloadAll: true,
                });
                break;
            }
          },
          navMain: function (...params) {
            //check if reminderNotification is not set then set local notification for weekly updates
            if (f7.device.cordova) {
              let id = new Date().getMilliseconds();
              let sound = !f7.device.ios
                ? "file://static/sound.mp3"
                : "file://static/sound.caf";
              if (localStorage.getItem("reminderNotification") === null) {
                localStorage.setItem("reminderNotification", "true");

                cordova.plugins.notification.local.hasPermission((granted) => {
                  if (!granted) {
                    cordova.plugins.notification.local.requestPermission(
                      (granted) => {
                        schedule();
                      },
                    );
                  } else {
                    schedule();
                  }
                });

                function schedule() {
                  cordova.plugins.notification.local.schedule({
                    id: 199110080367,
                    title: "Welcome!",
                    text: "With Easychaw you can access all your favorite restaurants and vendors in one place! With just a click you can make orders and get it delivered to your door all from the convenience of your home!",
                    sound: sound,
                    foreground: true,
                    trigger: { in: 1, unit: "minute" },
                  });

                  cordova.plugins.notification.local.schedule({
                    id: id,
                    title: "More Menu Options!",
                    text: "We have added new merchants in your area with more menu options at amazing prices, log into the app to view these merchants.",
                    badge: 1,
                    sound: sound,
                    trigger: { every: "week", every: { hour: 15 } },
                    foreground: true,
                  });

                  cordova.plugins.notification.local.on(
                    "click",
                    function (notification) {
                      cordova.plugins.notification.badge.clear();
                    },
                  );
                }
              }
            }

            localStorage.setItem("intro", true);

            params[0] == "onboarding"
              ? localStorage.setItem("onboarding", true)
              : localStorage.setItem("onboarding", false);
            let page = params[0] == "onboarding" ? "/onboarding/" : "/map/";

            this.views.main.router.navigate(page, {
              reloadAll: true,
              reloadCurrent: params[1] ? true : false,
            });
          },
          navMessage: (...message) => {
            const app = this.$f7;
            const text = message[0]
              ? message[0]
              : "Please order from merchant menu.";
            toast(app.toast, {
              text: text,
              position: "center",
              horizontalPosition: "center",
              cssClass: "custom-toast",
              closeTimeout: 3000,
            });
          },
          copyText: function (e, caption) {
            const self = this;
            const html = e.target;
            const text = self.$(html).parent().find(".copytext").text();

            if (!navigator.clipboard) {
              return;
            }
            navigator.clipboard.writeText(text).then(
              function () {
                if (text == null || "") {
                  toast(self.toast, {
                    text: "Uhmm please try again...",
                    position: "center",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                } else {
                  toast(self.toast, {
                    text: caption + " <b>" + text + "</b> copied to clipboard",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                }
              },
              function (err) {},
            );
          },
          scrollTo: function (...params) {
            let app = params[0];
            let $el = params[1];

            let el = document.getElementById($el.split("#")[1]);

            // Animate scroll to the selected section
            if (el)
              el.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              });
            else
              toast(app.toast, {
                text: "No meals in this category",
                position: "center",
                horizontalPosition: "center",
                cssClass: "custom-toast",
                closeTimeout: 3000,
              });
          },
          vitalStatus: function (f7) {
            let checkNetwork, checkLocation;

            let interval = {
              // to keep a reference to all the intervals
              intervals: new Set(),

              // create another interval
              make(callback, ms, ...args) {
                var newInterval = setInterval(callback, ms, ...args);
                this.intervals.add(newInterval);
                return newInterval;
              },

              // clear a single interval
              clear(id) {
                this.intervals.delete(id);
                return clearInterval(id);
              },

              // clear all intervals
              clearAll() {
                for (var id of this.intervals) {
                  this.clear(id);
                }
              },
            };

            let dialog = (...params) => {
              let text = !navigator.onLine
                ? "Device is currently offline, please check network connection."
                : "Please enable device location, your location is required to display merchants.";

              if (params[0] != null) text = params[0];

              toast(f7.toast, {
                text,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                // closeTimeout: 4000,
                on: {
                  open: function () {
                    interval.clearAll();
                  },
                  close: function () {
                    vitals.init();
                  },
                },
              });
            };

            let vitals = {
              _network: function () {
                checkNetwork = interval.make(function () {
                  if (!navigator.onLine) dialog();

                  // if(navigator.connection)
                  //   if(navigator.connection.downlink < 1) dialog(`${navigator.connection.effectiveType} network speed is slow, please check connections for better performance`)
                }, 1000);
              },
              _location: function () {
                if (navigator.geolocation) {
                  checkLocation = interval.make(function () {
                    if (navigator.permissions)
                      navigator.permissions
                        .query({ name: "geolocation" })
                        .then(function (result) {
                          if (result.state === "granted") {
                          } else if (result.state === "prompt") {
                            dialog();
                          } else {
                            // show toast if the permission was denied.
                            dialog();
                          }
                        });
                  }, 1000);
                } else {
                  dialog(
                    "⚠ Geolocation API undected in browser, please update device.",
                  );
                }
              },
              init: function () {
                this._network();
                this._location();
              },
            };

            vitals.init();

            //Show caution to users if they open developers console
            const styles = `padding: 5px; background-color: #B71C1C; color: white;
                            font-style:  bold; border: 5px solid #c80000; font-size: 2em;`;
            console.error(
              "%cDanger! Please close this console and do not share any information to anyone!",
              styles,
            );
          },
          textClip: function (text, char) {
            let count = char || 20;
            return text.length > count
              ? text.substring(0, count).trim().concat("...")
              : text;
          },
          glow: function (...color) {
            this.$(".glow-tag").removeClass("glow color-green color-blue");
            setTimeout(
              () => this.$(".glow-tag").addClass("glow " + color[0]),
              500,
            );
          },
          notificationBell: (operation) => {
            if (operation == "open") {
              this.setState({
                ...this.state,
                popupOpened: true,
                popupDataChanged: true,
                popupData: {
                  title: "Notifications",
                  which: "notification",
                },
              });
            }

            if (
              !this.props.loadingDocs &&
              this.props.notifications &&
              this.props.notifications.length !== 0 &&
              this.props.notifications.filter((message) =>
                message.reads.find((id) => id === this.props.auth.uid)
                  ? false
                  : true,
              ).length !== 0
            ) {
              return {
                messages: this.props.notifications.filter((message) =>
                  message.reads.find((id) => id === this.props.auth.uid)
                    ? false
                    : true,
                ).length,
              };
            } else {
              return { messages: null };
            }
          },
        },

        // App touch
        touch: {
          tapHold: true, //enable tap hold events
          auroraTouchRipple: true,
        },

        // App routes
        routes: routes,

        // Input settings
        input: {
          scrollIntoViewOnFocus: this.$device.cordova && !this.$device.electron,
          scrollIntoViewCentered:
            this.$device.cordova && !this.$device.electron,
        },
        // Cordova Statusbar settings
        statusbar: {
          iosOverlaysWebView: true,
          androidOverlaysWebView: false,
        },

        on: {
          tabMounted: function (e) {},
        },

        // lazy load image params
        lazy: {
          threshold: 400,
          sequential: false,
          placeholder: "./static/poster.png",
        },
      },

      //  Popup
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },

      serviceWorkerRegistration: null,
    };
  }
  render() {
    return (
      <App params={this.state.f7params}>
        {/* Right panel with cover effect*/}
        <Panel right cover swipe swipeOnlyClose>
          <View>
            <Page>
              <Block
                className="pattern-banner bg-color-jasmine"
                style={{ backgroundSize: "50%" }}
              >
                <Card style={{ width: "100%", margin: 0 }}>
                  <CardHeader>
                    <h3 style={{ margin: 0 }}>Search Filter</h3>
                  </CardHeader>
                </Card>
              </Block>
              <Block>
                <BlockTitle>Search radius</BlockTitle>
                <List simpleList>
                  <ListItem>
                    <ListItemCell className="width-auto flex-shrink-0">
                      <Icon f7="car_fill"></Icon>
                    </ListItemCell>
                    <ListItemCell className="flex-shrink-3">
                      <Range
                        value={this.state.searchRadius}
                        step={5}
                        min={0}
                        max={100}
                        label={true}
                        onRangeChanged={(e) => {
                          this.$f7.$("#radius").text(e);
                          this.props.dispatch({
                            type: CHANGE_RANGE,
                            payload: e,
                          });
                        }}
                      ></Range>
                    </ListItemCell>
                    <ListItemCell className="width-auto flex-shrink-0">
                      <h6>
                        <span id="radius">{this.state.searchRadius}</span>
                        km
                      </h6>
                    </ListItemCell>
                  </ListItem>
                </List>
                <Row>
                  <Col width="100">
                    <List simpleList>
                      <BlockTitle>Edit Location </BlockTitle>
                      <ListItem>
                        <ListItemCell className="width-auto flex-shrink-0">
                          <Icon f7="map_pin_ellipse"></Icon>
                        </ListItemCell>
                        <ListItemCell
                          className="flex-shrink-3"
                          style={{
                            overflow: "hidden",
                          }}
                        >
                          <Link
                            panelClose
                            href="#"
                            style={{
                              color: "#161616",
                            }}
                            onClick={() => {
                              window.history.pushState({}, document.title, "/");
                              this.$f7.methods.navMain("map");
                            }}
                          >
                            <small id="locationFromMap">Your location...</small>
                          </Link>
                        </ListItemCell>
                      </ListItem>
                    </List>
                  </Col>
                </Row>
                <List>
                  <BlockTitle>Meal menu</BlockTitle>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("African Dishes")}
                    onChange={this.menuChange.bind(this)}
                    value="African Dishes"
                    title="African Dishes"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Cakes")}
                    onChange={this.menuChange.bind(this)}
                    value="Cakes"
                    title="Cakes"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Chinese Dishes")}
                    onChange={this.menuChange.bind(this)}
                    value="Chinese Dishes"
                    title="Chinese Dishes"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Drinks")}
                    onChange={this.menuChange.bind(this)}
                    value="Drinks"
                    title="Drinks"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Foreign Dishes")}
                    onChange={this.menuChange.bind(this)}
                    value="Foreign Dishes"
                    title="Foreign Dishes"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Fruits")}
                    onChange={this.menuChange.bind(this)}
                    value="Fruits"
                    title="Fruits"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Shawarma")}
                    onChange={this.menuChange.bind(this)}
                    value="Shawarma"
                    title="Shawarma"
                  ></ListItem>
                  <ListItem
                    checkbox
                    name="menu-checkbox"
                    checked={this.state.menu.includes("Snacks")}
                    onChange={this.menuChange.bind(this)}
                    value="Snacks"
                    title="Snacks"
                  ></ListItem>
                </List>
              </Block>
            </Page>
          </View>
        </Panel>

        {/* Left panel with cover effect*/}
        <Panel left cover swipe swipeOnlyClose>
          <View>
            <Page
              style={{
                backgroundColor: "rgba(254, 212, 72, 0.46)",
                marginTop: 0,
              }}
              id="menu-panel"
            >
              <img
                src="static/pattern.png"
                style={{ width: "100%", objectFit: "cover", height: "260px" }}
              />
              <Block id="panel-menu-left">
                <Row>
                  <Col width="100">
                    <Link
                      tabLink="#view-map"
                      panelClose
                      onClick={() => this.$f7.methods.navMain("map")}
                    >
                      <i className="f7-icons">house</i>
                      I'm Hungry
                    </Link>
                  </Col>
                  {this.props.auth && this.props.auth.uid ? (
                    <>
                      <Col width="100">
                        <Link
                          tabLink="#view-account"
                          onClick={() => this.$f7.methods.navAccount("profile")}
                          panelClose
                        >
                          <i className="f7-icons">person</i>
                          Profile
                        </Link>
                      </Col>
                      <Col width="100">
                        <Link
                          tabLink="#view-account"
                          onClick={() =>
                            this.$f7.methods.navAccount("business")
                          }
                          panelClose
                        >
                          <i className="f7-icons">briefcase</i>
                          Partner
                        </Link>
                      </Col>
                      <Col
                        width="100"
                        className={
                          parseInt(window.innerWidth) <= 800 ? "show" : "hide"
                        }
                      >
                        <List className="customMenuList">
                          <ListItem>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <i className="f7-icons">equal_circle</i>
                            </ListItemCell>
                            <ListItemCell
                              className="flex-shrink-3"
                              style={{ marginLeft: 0 }}
                            >
                              <Link>Quick Menu</Link>
                            </ListItemCell>
                            <ListItemCell className="width-auto flex-shrink-0">
                              <Toggle
                                color="black"
                                onToggleChange={(e) => this.quickMenu(e)}
                                defaultChecked={
                                  localStorage.quickMenu == "true"
                                }
                              ></Toggle>
                            </ListItemCell>
                          </ListItem>
                        </List>
                      </Col>
                      <Col width="100">
                        <Link onClick={this.signOut.bind(this)} panelClose>
                          <i className="f7-icons">lock_open_fill</i>
                          Sign Out
                        </Link>
                      </Col>
                    </>
                  ) : (
                    <Col width="100">
                      <Link
                        tabLink="#view-map"
                        panelClose
                        onClick={() => {
                          window.history.pushState({}, document.title, "/");
                          this.$f7.methods.navMain("onboarding");
                        }}
                      >
                        <i className="f7-icons">lock_fill</i>
                        Sign In
                      </Link>
                    </Col>
                  )}
                  <Col width="100">
                    <Link
                      tabLink="#view-account"
                      onClick={() => this.$f7.methods.navAccount("info")}
                      panelClose
                    >
                      <i className="f7-icons">info_circle</i>
                      Info
                    </Link>
                  </Col>
                  <Col width="100">
                    <List className="customMenuList">
                      <ListItem>
                        <ListItemCell className="width-auto flex-shrink-0">
                          <i className="f7-icons">lightbulb</i>
                        </ListItemCell>
                        <ListItemCell
                          className="flex-shrink-3"
                          style={{ marginLeft: 0 }}
                        >
                          <Link>Map Dark Mode</Link>
                        </ListItemCell>
                        <ListItemCell className="width-auto flex-shrink-0">
                          <Toggle
                            color="black"
                            onToggleChange={(e) => {
                              localStorage.mapDarkMode = e;
                              this.$f7.methods.navMain("map", "reloadCurrent");
                            }}
                            defaultChecked={localStorage.mapDarkMode == "true"}
                          ></Toggle>
                        </ListItemCell>
                      </ListItem>
                    </List>
                  </Col>
                </Row>
              </Block>
            </Page>
          </View>
        </Panel>

        {/* Views/Tabs container */}
        <Views tabs className="safe-areas">
          {/* Your main view/tab, should have "view-main" class. It also has "tabActive" prop */}
          <View
            id="view-map"
            tab
            name="map"
            url="/"
            main
            masterDetailBreakpoint={800}
            auroraSwipeBack={true}
            tabActive={true}
            passRouteParamsToRequest={true}
            // pushState={true}
          />

          {/* Account View */}
          <View
            id="view-account"
            tab
            name="account"
            url="/account/"
            masterDetailBreakpoint={800}
            // auroraSwipeBack={true}
            loadInitialPage={false}
          />

          {/* Messagea View */}
          <View
            id="view-message-master"
            tab
            name="message-master"
            url="/message-master/"
            masterDetailBreakpoint={800}
            loadInitialPage={false}
          />
        </Views>

        {/* Floating menu button */}
        {this.props.auth && this.props.auth.uid ? (
          <Fmb account={this.$f7.methods.navAccount.bind(this)} />
        ) : null}

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
            })
          }
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for notifications */}
            {this.state.popupData.which == "notification" ? (
              <div>
                <Block
                  className="bg-color-theme bg-image-pattern"
                  strong
                  style={{
                    margin: 0,
                    width: "100%",
                    minHeight: "190px",
                  }}
                >
                  <div className="glass-effect">
                    {/* if background mode is enabled via cordova/web notification is allowed */}
                    {!("Notification" in window) ||
                    !("serviceWorker" in navigator) ? (
                      <>
                        <h3>Push notifications</h3>
                        <p>
                          You will be notified of best updates and new offers.
                        </p>
                      </>
                    ) : this.props.auth.uid && !this.state.pushNotification ? (
                      <>
                        <h3>Turn on push notifications</h3>
                        <p>
                          You will be notified when best updates and new offers
                          arrive.
                        </p>
                        <Button
                          style={{
                            width: "100px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "1px solid white",
                          }}
                          onClick={this.enablePushNotification.bind(this)}
                        >
                          Enable now
                        </Button>
                      </>
                    ) : (
                      <>
                        <h3>Turn off push notifications</h3>
                        <p>
                          You will not be notified of best updates and new
                          offers.
                        </p>
                        <Button
                          style={{
                            width: "100px",
                            backgroundColor: "#F44336",
                            color: "white",
                            border: "1px solid white",
                          }}
                          onClick={() =>
                            this.$f7.dialog.confirm(
                              "Turning this off will disable your push notification alerts!",
                              "Turn off push notifications?",
                              this.disablePushNotification.bind(this),
                            )
                          }
                        >
                          Turn off
                        </Button>
                      </>
                    )}
                  </div>
                </Block>

                <Block>
                  {!this.props.loadingDocs &&
                  this.props.notifications &&
                  this.props.notifications.length > 0 ? (
                    this.props.notifications
                      .sort(
                        (a, b) => parseInt(b.timestamp) - parseInt(a.timestamp),
                      )
                      .map((notification) => (
                        <Card
                          style={{ margin: "10pt auto" }}
                          inner
                          accordionList
                          key={notification.id}
                        >
                          <AccordionItem
                            onAccordionOpened={() => {
                              if (
                                !notification.reads.find(
                                  (userId) => userId === this.props.auth.uid,
                                )
                              ) {
                                this.props.firestore
                                  .collection("notification")
                                  .doc(notification.id)
                                  .update({
                                    reads: [
                                      ...notification.reads,
                                      this.props.auth.uid,
                                    ],
                                  })
                                  .catch((error) => {
                                    toast(this.$f7.toast, {
                                      text: handleErrors(error),
                                      position: "bottom",
                                      horizontalPosition: "center",
                                      closeButton: true,
                                      cssClass: "custom-toast",
                                      closeTimeout: 4000,
                                    });
                                  });
                              }
                            }}
                          >
                            <AccordionToggle>
                              <CardHeader>
                                {/* Use readBellTitle if the message has been read */}
                                <p
                                  className={
                                    notification.reads.find(
                                      (userId) =>
                                        userId === this.props.auth.uid,
                                    )
                                      ? "readBellTitle"
                                      : ""
                                  }
                                >
                                  {notification.title}
                                </p>
                                <img
                                  src="static/icon-512x512@1x.png"
                                  width="40"
                                />
                              </CardHeader>
                            </AccordionToggle>

                            <AccordionContent>
                              <CardContent>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: notification.body,
                                  }}
                                ></div>
                              </CardContent>

                              <CardFooter>
                                <small>
                                  <Icon f7="clock" /> |{" "}
                                  {moment(notification.timestamp).fromNow()}
                                </small>
                                {/* if admin is logged in show delete button */}
                                {this.props.profile.role === "Admin" ? (
                                  <Button
                                    fill
                                    width="50%"
                                    onClick={(e) =>
                                      this.deleteNotification(notification.id)
                                    }
                                  >
                                    Delete
                                  </Button>
                                ) : null}
                              </CardFooter>
                            </AccordionContent>
                          </AccordionItem>
                        </Card>
                      ))
                  ) : (
                    <div style={{ textAlign: "center", marginTop: "16%" }}>
                      <img
                        src="static/subscriber.svg"
                        style={{ width: "300px" }}
                      />
                      <h6>No Notifications</h6>
                    </div>
                  )}
                </Block>
              </div>
            ) : null}
          </Page>
        </Popup>
      </App>
    );
  }

  //events
  menuChange(e) {
    if (e.target.checked) {
      this.setState({
        ...this.state,
        menu: [...this.state.menu, e.target.value],
      });
      this.props.dispatch({ type: CHANGE_MENU_ADD, payload: e.target.value });
    } else {
      this.setState({
        ...this.state,
        menu: this.state.menu.filter((menu) => menu !== e.target.value),
      });
      this.props.dispatch({
        type: CHANGE_MENU_REMOVE,
        payload: e.target.value,
      });
    }
  }

  quickMenu(e) {
    const self = this;
    localStorage.quickMenu = e;
    e
      ? self.$f7.$("#fmb").show().addClass("glow")
      : this.$f7.$("#fmb").hide().removeClass("glow");
  }

  signOut() {
    this.$f7.preloader.show();
    // delete players collection with onesignal playerID
    if (this.$f7.device.ios || this.$f7.device.android) {
      this.props.firebase
        .firestore()
        .collection("players")
        .doc(this.props.auth.uid)
        .delete()
        .then(() => {
          this.props.firebase
            .auth()
            .signOut()
            .then(() => {
              if (localStorage.getItem("cart")) {
                localStorage.removeItem("cart");
                this.props.dispatch({ type: CART, payload: null });
              }
              this.$f7.preloader.hide();
              this.$f7.tab.show("#view-map");
              this.$f7.methods.navMain("onboarding");
            })
            .catch((error) => {
              toast(this.$f7.toast, {
                text: handleErrors(error),
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            });
        })
        .catch((error) => {
          console.log("playerID registration failed" + error);
        });
    } else {
      this.props.firebase
        .auth()
        .signOut()
        .then(() => {
          if (localStorage.getItem("cart")) {
            localStorage.removeItem("cart");
            this.props.dispatch({ type: CART, payload: null });
          }
          this.$f7.preloader.hide();
          this.$f7.tab.show("#view-map");
          this.$f7.methods.navMain("onboarding");
        })
        .catch((error) => {
          toast(this.$f7.toast, {
            text: handleErrors(error),
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });
    }
  }

  // enable push notification
  enablePushNotification() {
    this.$f7.preloader.show();

    if ("serviceWorker" in navigator) {
      runtime
        .register()
        .then((registration) => {
          registration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(
                "BKEez2rHM4cM4kDDDoldnPLaksWUE8g_FKXMJtjN2ipa8L2NtMBQsYoH0dSe31JOlF-Uev64rgWLRcDx7Bjc-Lg",
              ),
            })
            .then((subscription) => {
              this.props.firestore
                .collection("notificationToken")
                .doc(this.props.auth.uid)
                .set({ token: JSON.stringify(subscription) })
                .then(() => {
                  this.setState({
                    ...this.state,
                    pushNotification: true,
                  });
                  localStorage.setItem("allowPushNotification", "yes");
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: "Push notification enabled",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                })
                .catch((error) => {
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: "Something went wrong, unable to enable push notification. Please try again.",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                });
            })
            .catch((error) => {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: "Something went wrong, unable to enable push notification. Please try again.",
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            });
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          return toast(this.$f7.toast, {
            text: "Something went wrong, unable to enable push notification. Please try again.",
            position: "bottom",
            horizontalPosition: "center",
            closeButton: true,
            cssClass: "custom-toast",
            closeTimeout: 4000,
          });
        });
    }
  }

  // disable push notification
  disablePushNotification() {
    this.$f7.preloader.show();
    this.props.firestore
      .collection("notificationToken")
      .doc(this.props.auth.uid)
      .delete()
      .then(() => {
        this.setState({
          ...this.state,
          pushNotification: false,
        });
        localStorage.setItem("allowPushNotification", "no");
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Push Notification Disabled.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Something went wrong, unable to disable push notification. Please try again.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  // delete notification
  deleteNotification(id) {
    // delete notification
    this.$f7.preloader.show();
    this.props.firestore
      .collection("notification")
      .doc(id)
      .delete()
      .then(() => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Notification Deleted.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: "Something went wrong, notification was not deleted. Please try again.",
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !nextProps.auth.isEmpty &&
      nextProps.profile.isLoaded &&
      prevState.serviceWorkerRegistration !== null
    ) {
      if ("Notification" in window) {
        if (
          Notification.permission === "default" ||
          (Notification.permission === "granted" &&
            localStorage.getItem("allowPushNotification") &&
            localStorage.getItem("allowPushNotification") === "yes") ||
          (Notification.permission === "granted" &&
            !localStorage.getItem("allowPushNotification"))
        ) {
          prevState.serviceWorkerRegistration.pushManager
            .subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(
                "BKEez2rHM4cM4kDDDoldnPLaksWUE8g_FKXMJtjN2ipa8L2NtMBQsYoH0dSe31JOlF-Uev64rgWLRcDx7Bjc-Lg",
              ),
            })
            .then((subscription) => {
              nextProps.firestore
                .collection("notificationToken")
                .doc(nextProps.auth.uid)
                .set({ token: JSON.stringify(subscription) })
                .catch((error) => {});
            })
            .catch((error) => {});
        }
      }
    }

    return null;
  }

  componentDidMount() {
    this.$f7ready((f7) => {
      // Init cordova APIs (see cordova-app.js)
      if (f7.device.cordova) {
        cordovaApp.init(f7);
      }
      // Call F7 APIs here
      this.props.initAuth(this.props.firebase, f7);

      if ("serviceWorker" in navigator) {
        runtime
          .register()
          .then((registration) => {
            this.setState({
              ...this.state,
              serviceWorkerRegistration: registration,
            });
          })
          .catch((error) =>
            this.setState({ ...this.state, serviceWorkerRegistration: null }),
          );
      }

      // get allowPushNotification from localStorage
      this.setState({
        ...this.state,
        pushNotification:
          !localStorage.getItem("allowPushNotification") ||
          localStorage.getItem("allowPushNotification") === "yes"
            ? true
            : false,
      });

      this.$f7.methods.notificationBell();

      // update search radius
      this.props.firestore
        .collection("settings")
        .doc("easychaw")
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.setState({
              ...this.state,
              searchRadius: doc.data().defaultSearchRadius,
            });
            this.props.dispatch({
              type: CHANGE_RANGE,
              payload: doc.data().defaultSearchRadius,
            });

            // check if this app is latest version
            const iosVersionFromDb = doc.data().iosVersion;
            const androidVersionFromDb = doc.data().androidVersion;
            const appVersionLocal = this.state.f7params.version;

            if (f7.device.cordova) {
              if (f7.device.ios && appVersionLocal != iosVersionFromDb) {
                const newUpdate = f7.dialog.create({
                  title: "New Update",
                  text: `A new and improved version of the Easychaw app is available in app store, please download update.`,
                  cssClass: "new-update",
                  buttons: [
                    {
                      text: "Download Update",
                      onClick: function (dialog, e) {
                        // go to store
                        f7.methods.intents.openStore(
                          "https://apps.apple.com/us/app/easychaw/id1512095908",
                        );
                      },
                      close: false,
                    },
                  ],
                  verticalButtons: true,
                  closeByBackdropClick: false,
                });
                newUpdate.open();
              } else if (
                f7.device.android &&
                appVersionLocal != androidVersionFromDb
              ) {
                const newUpdate = f7.dialog.create({
                  title: "New Update",
                  text: `A new and improved version of the Easychaw app is available in playstore, please download update.`,
                  cssClass: "new-update",
                  buttons: [
                    {
                      text: "Download Update",
                      onClick: function (dialog, e) {
                        // go to store
                        f7.methods.intents.openStore(
                          "https://play.google.com/store/apps/details?id=com.easychaw.webapp",
                        );
                      },
                      close: false,
                    },
                  ],
                  verticalButtons: true,
                  closeByBackdropClick: false,
                });
                newUpdate.open();
              }
            }
          }
        })
        .catch((error) => {});

      //check browser network status, geolocation status
      this.$f7.methods.vitalStatus(f7);

      // check if url has merchant name
      let searchMerchant = window.location.search.split("=");
      if (searchMerchant.length > 1) this.$f7.methods.navMain("map");
    });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: {
    data,
    docs: { notification, loading },
  },
}) => ({
  auth,
  profile,
  data,
  loadingDocs: loading,
  notifications: (notification && notification) || [],
});

const mapDispatchToProps = (dispatch) => ({
  initAuth: (firebase, f7) => dispatch(initAuth(firebase, f7)),
});

const enhancer = compose(
  withFirebase,
  withFirestore,
  firebaseConnect,
  firestoreConnect((props) => [
    // new Collections('products'),
    new DocArray("notification", `All,${props.auth.uid}`, "to", props),
  ]),
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhancer(MainApp);
